import type { FeatureFlag } from '@swf/core/enums';
import type { ModelConfig } from '@swf/core/store';
import { canUseDOM } from '@swf/core/utils';
import { tryParse } from '@swf/core/utils/api';

import check from './check';
import selectors from './selectors';

export type Feature = Partial<
  {
    [key in FeatureFlag]: boolean;
  }
>;

export type FeatureState = Feature;

const overrides: FeatureState | false =
  canUseDOM && tryParse(localStorage.getItem('starsweb-features'));

const reducers = {
  'persist/REHYDRATE': (state: Feature) => ({ ...state, ...overrides }),
  update: (state: Feature, payload: Feature) => ({ ...state, ...payload, ...overrides })
};

const effects = { check };

interface FeatureModel extends ModelConfig<FeatureState> {
  effects: typeof effects;
  reducers: typeof reducers;
  selectors: typeof selectors;
}

const feature: FeatureModel = {
  state: overrides || {},
  effects,
  reducers,
  selectors
};

export default feature;
